export default function ({ store, next, redirect }) {
    if (store.getters['profile/role'] !== 'investor') {
        redirect('/')
    }
}